

import {Component, input, OnInit, ViewEncapsulation} from "@angular/core";

import {
  IAlertCommentController,
  IT_ALERT_COMMENT_CONTROLLER,
  MK_ALERT_COMMENT
} from "../_controllers/IAlertCommentController";
import {AlertCommentModel} from "../_models/AlertCommentModel";
import {AbstractView} from "../../../views/AbstractView";
import {AlertData} from "../../../interfaces/domain/alert/AlertData";
import {AlertComment} from "../../../interfaces/rest/AlertComment";
import {AlertCommentController} from "../_controllers/alert-comment.controller";

@Component({
  selector: 'link-alert-comment',
  templateUrl: './alert-comment.view.html',
  styleUrls: ['./alert-comment.view.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: IT_ALERT_COMMENT_CONTROLLER, useClass: AlertCommentController },
  ]
})
export class AlertCommentView extends AbstractView<IAlertCommentController> implements OnInit {

  newComment = input<string | undefined>();
  alertData = input<AlertData | null>();
  commentsList = input<Array<AlertComment> | []>();
  alertInstanceId = input<string | null>();
  alertRuleId = input<string | null>();

  protected model: AlertCommentModel;
  commentMessage: '' | undefined;

  constructor() {
    super(IT_ALERT_COMMENT_CONTROLLER);
    this.model = this.getController().getModel(MK_ALERT_COMMENT);
  }

  ngOnInit(): void {
    this.model.commentsList$.set(this.commentsList()!);
    this.model.alertRuleId$.set(this.alertRuleId()!);
    this.model.alertInstanceId$.set(this.alertInstanceId()!);
  }

  postComment(commentMessage: any) {
    this.getController().handle("PostComment", commentMessage);
  }
}
